/**
 * @file: store.service.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { HttpClient } from '@euler/lib/request';

export class OrganizationService {
  constructor(private readonly api: HttpClient) {}

  async getIsWeixinOpenAuthorized(): Promise<boolean> {
    return await this.api.get().url('/org/is-weixin-open-authorized').future();
  }
}
